module.exports = __webpack_public_path__ + "img/Contrast.33412813.svg";